/**
 * Safely sets a single property in a multi-property CSS value.
 * @param  {String} value The multi-property value.
 * @param  {String} property The property to set.
 * @param  {String} propertyValue The property's new value.
 * @return {String|undefined}
 * @example
 *
 * const transform = 'translate(0, 0) rotate(35deg)';
 * setMultiValueProperty(transform, 'rotate', '0deg'); // "translate(0, 0) rotate(0deg)"
 */
const setMultiValueProperty = (value, property, propertyValue) => {
    const newPropertyValue = `${property}(${propertyValue})`;
    const regex = new RegExp(`${property}\\((.*?)\\)`);

    if (value.match(regex)) {
        return value.replace(regex, newPropertyValue);
    }

    return `${value} ${newPropertyValue}`;
};

module.exports = setMultiValueProperty;
